import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

const BASE_URL = '/pricing';

export default function PricingComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(PricingComponent, {
        get({ productId, rateId, filterFirstTimeUnitStartUtc, filterLastTimeUnitStartUtc, extent }: $TSFixMe) {
            return request('/get', {
                productId,
                rateId,
                filterFirstTimeUnitStartUtc,
                filterLastTimeUnitStartUtc,
                extent,
            });
        },

        updateBasePrice({
            value,
            currencyCode,
            taxValues,
            productId,
            rateId,
            filterFirstTimeUnitStartUtc,
            filterLastTimeUnitStartUtc,
            taxExemptionReasonCode,
            taxExemptionLegalReference,
        }: $TSFixMe) {
            return request('/updateBasePrice', {
                value,
                currencyCode,
                taxValues,
                productId,
                rateId,
                filterFirstTimeUnitStartUtc,
                filterLastTimeUnitStartUtc,
                taxExemptionReasonCode,
                taxExemptionLegalReference,
            });
        },

        updateRateDependency({
            absoluteAdjustment,
            relativeAdjustment,
            productId,
            rateId,
            attributeType,
            filterFirstTimeUnitStartUtc,
            filterLastTimeUnitStartUtc,
        }: $TSFixMe) {
            return request('/updateRateDependency', {
                absoluteAdjustment,
                relativeAdjustment,
                productId,
                rateId,
                attributeType,
                filterFirstTimeUnitStartUtc,
                filterLastTimeUnitStartUtc,
            });
        },

        updateDependency({
            attributeType,
            attributeId,
            baseAttributeId,
            productId,
            rateId,
            filterFirstTimeUnitStartUtc,
            filterLastTimeUnitStartUtc,
            relativeValue,
            absoluteValue,
        }: $TSFixMe) {
            return request('/updateDependency', {
                attributeType,
                attributeId,
                baseAttributeId,
                productId,
                rateId,
                filterFirstTimeUnitStartUtc,
                filterLastTimeUnitStartUtc,
                relativeValue,
                absoluteValue,
            });
        },

        updateCapacityOffsets({
            negativeOccupancyAdjustment,
            extraOccupancyAdjustment,
            ageCategoryOffsetAdjustments,
            attributeType,
            productId,
            rateId,
            filterFirstTimeUnitStartUtc,
            filterLastTimeUnitStartUtc,
        }: $TSFixMe) {
            return request('/updateCapacityOffsets', {
                negativeOccupancyAdjustment,
                extraOccupancyAdjustment,
                ageCategoryOffsetAdjustments,
                attributeType,
                productId,
                rateId,
                filterFirstTimeUnitStartUtc,
                filterLastTimeUnitStartUtc,
            });
        },

        set({
            attributeType,
            attributeId,
            adjustmentFirstTimeUnitStartUtc,
            adjustmentLastTimeUnitStartUtc,
            days,
            hours,
            value,
            productId,
            rateId,
            filterFirstTimeUnitStartUtc,
            filterLastTimeUnitStartUtc,
        }: $TSFixMe) {
            return request('/set', {
                attributeType,
                attributeId,
                adjustmentFirstTimeUnitStartUtc,
                adjustmentLastTimeUnitStartUtc,
                days,
                hours,
                value,
                productId,
                rateId,
                filterFirstTimeUnitStartUtc,
                filterLastTimeUnitStartUtc,
            });
        },

        clear({
            attributeType,
            attributeId,
            adjustmentFirstTimeUnitStartUtc,
            adjustmentLastTimeUnitStartUtc,
            days,
            hours,
            productId,
            rateId,
            filterFirstTimeUnitStartUtc,
            filterLastTimeUnitStartUtc,
        }: $TSFixMe) {
            return request('/clear', {
                attributeType,
                attributeId,
                adjustmentFirstTimeUnitStartUtc,
                adjustmentLastTimeUnitStartUtc,
                days,
                hours,
                productId,
                rateId,
                filterFirstTimeUnitStartUtc,
                filterLastTimeUnitStartUtc,
            });
        },
    });
}
